'use client';

import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import ErrorMessage from './ErrorMessage';

const handleOnError = (e?: unknown) => {
    try {
        const error = e as Error;
        const { message, stack } = error;
        console.warn(message, stack);
    } catch (err) {
        console.warn(err);
    }
};

function ErrorBoundary({ children }: { children: React.ReactNode }) {
    return (
        <ReactErrorBoundary fallback={<ErrorMessage />} onError={handleOnError}>
            {children}
        </ReactErrorBoundary>
    );
}

export default ErrorBoundary;
